import React, { useState, useEffect } from 'react';
import MenuAdmin from '../../../../components/layout/menu';
import standimage from '../../../../assets/images/location/stands/stands.png';
import location from '../../../../assets/images/location/stands/location.png'
import { getSites } from '../../../../client/administration/sites/index';
import { getStands } from '../../../../client/administration/stands/index';
import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';
import ContentLoader from 'react-content-loader'; // Importamos el ContentLoader
import Programate from '../../../../components/layout/footer';

const Plantas = () => {
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const [openMenu, setOpenMenu] = useState(null);  // Estado para abrir/cerrar el menú de cada planta

    const [siteData, setSiteData] = useState([]);
    const [standData, setStandData] = useState([]);

    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const toggleMenu = () => setIsMenuOpen(!isMenuOpen); 
    const customIcon = new L.Icon({
        iconUrl: location, //icon
        iconSize: [17.6, 20.3], // Tamaño del icono
        iconAnchor: [12, 41], // Punto del icono que se alineará con la posición del marcador
        popupAnchor: [1, -34], // Punto desde el cual se abrirá el popup
    });

    // Cargar los datos de los sitios
    useEffect(() => {
        const fetchData = async () => {
            try {
                const siteResponse = await getSites();
                const standResponse = await getStands();
                setSiteData(siteResponse.data);
                setStandData(standResponse.data);
                setLoading(false);
            } catch (err) {
                setError(err.message || "Error al cargar los datos");
                setLoading(false);
            }
        };

        fetchData();
    }, []);

    // Función para manejar el clic y alternar entre abrir y cerrar el menú
    const handleMenuClick = (menuName) => {
        setOpenMenu(openMenu === menuName ? null : menuName);
    };

    const renderMenu = (site) => {
        const { siteName, latitude, longitude, direction } = site;
        const relatedStands = standData.filter(stand => stand.idSite === site.id); // Filtrar casetas relacionadas

        return (
            <div className="relative py-4">
                {/* Botón para abrir/cerrar el menú */}
                <button
                    onClick={() => handleMenuClick(siteName)}
                    className="flex justify-between items-center p-2 text-[#007696] text-[24px] font-itcmedium border border-[#808080] w-full"
                >
                    <p className="ml-4">{siteName}</p>
                    <div className="mr-6 border-l-[7px] border-r-[7px] border-t-[7px] border-transparent border-t-[#808080]" /> {/* Flecha hacia abajo */}
                </button>

                {/* Contenido del menú desplegable */}
                {openMenu === siteName && (
                    <div className="w-full pl-3 mt-3 space-y-1 ">
                        {/* Contenedor para el mapa y la descripción */}
                        <div className="flex space-x-6 ">
                            {/* Mapa de la planta*/}
                            {latitude && longitude && (
                                <div className="w-1/2 h-[300px] sticky">
                                    <MapContainer 
                                        center={[latitude, longitude]} 
                                        zoom={15} 
                                        style={{ width: '100%', height: '100%' }}
                                    >
                                        <TileLayer
                                            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                                        />
                                        <Marker position={[latitude, longitude]} icon={customIcon}>
                                            <Popup>{direction}</Popup>
                                        </Marker>
                                    </MapContainer>
                                </div>
                            )}

                            {/* Información de la planta al lado del mapa */}
                            <div className="w-1/2">
                                <div className="text-[20px] font-itcbold text-[#007696] mb-2">Ubicación</div>
                                <div className="text-[16px] text-[#808080] font-itcmedium mb-4">{direction}</div>
                            </div>
                            
                        </div>
                        {/* Casetas */}
                             <div>
                                <div className="text-[20px] font-itcbold pt-5 text-[#007696] mb-2">Casetas</div>
                                <div className={`grid ${relatedStands.length === 3 ? 'sm:grid-cols-2' : 'sm:grid-cols-2 grid-cols-1'} gap-10`}>
                                {relatedStands.map((stand) => (
                                            <div key={stand.id} className="flex md:p-6 p-4 gap-4 border-[#808080] border-[1px] border-dashed ">
                                                <div className='w-1/2'>
                                                    <img 
                                                        src= {standimage}
                                                        alt="location" 
                                                        className="w-[204px] h-[180px] object-cover" 
                                                    />
                                                </div>
                                            
                                                <div className='w-1/2'>
                                                    <div className="text-[20px] font-itcmedium text-[#007696]">{stand.standName}</div>
                                                    <p className="text-[16px] text-[#808080] font-itcmedium mt-2">{stand.direction}</p>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                    </div>
                )}
            </div>
        );
    };

    return (
        <div className='flex w-full min-h-screen'>
            <MenuAdmin isMenuOpen={isMenuOpen} toggleMenu={toggleMenu} className="transition-all duration-300" />
            <div className={`flex-1 transition-all duration-300 ml-0 ${isMenuOpen ? "lg:ml-[216px] sm:ml-[0] md:ml-[0]" : "ml-0"} w-[87%] `}>
                <div className='flex flex-col min-h-screen justify-between'>
                    <div className='px-[4%] pb-8'>
                        <div className="flex  justify-start pt-28 lg:pt-32 pb-6 ">
                            {loading ? (
                                <ContentLoader
                                    viewBox="0 0 1200 200"
                                    height="100%"
                                    width="100%"
                                    backgroundColor="#f3f3f3"
                                    foregroundColor="#ecebeb"
                                    className='mt-2'
                                    speed={5}
                                >
                                    {/* Título "Plantas" */}
                                    <rect x="0" y="0" width="15%" height="40" rx="5" ry="5" /> {/* Título "Plantas" */}
                                </ContentLoader>
                            ) : (
                                <p className="text-[32px] font-itcbold text-[#007696] text-center ">Plantas</p>
                            )}
                        </div>
        
                        <div>
                            {loading ? (
                                <ContentLoader
                                    viewBox="0 0 1200 350"
                                    height="100%"
                                    width="100%"
                                    backgroundColor="#f3f3f3"
                                    foregroundColor="#ecebeb"
                                    className='-mt-14 sm:-mt-28'
                                    speed={5}
                                >
                                    <rect x="0" y="0" width="100%" height="60" rx="5" ry="5" /> 
                                    <rect x="0" y="90" width="100%" height="60" rx="5" ry="5" /> 
                                    <rect x="0" y="180" width="100%" height="60" rx="5" ry="5" /> 
                                </ContentLoader>
                            ) : (
                                siteData && siteData.map((site) => (
                                    renderMenu(site)  // Pasamos el nombre de cada planta
                                ))
                            )}
                        </div>
                    </div>
                    <Programate/>
                </div>
            </div>
        </div>
    );
};

export default Plantas;